import React, { Component } from 'react';
import LoadingRoute from '../loading-route/loading-route.component';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError)
      return <LoadingRoute error />;
    return this.props.children;
  }
}

export default ErrorBoundary;
